<template>
    <div class="row">
        <div class="position-relative w-100 p-2">
            <internal-notes
                :api-endpoints="internalNotesEndpoint"
                :user-type="'client'"
                :is-program="true"
            ></internal-notes>
        </div>
    </div>
</template>

<script>
import InternalNotes from "../ui/InternalNotes";

export default {
    name: "ProgramNotes",
    props: ["patient", "userId"],
    computed: {
        internalNotesEndpoint() {
            return {
                get: `/api/patients/${this.patient.id}/notes`,
                post: `/api/patients/${this.patient.id}/notes`,
            };
        },
    },
    components: {
        InternalNotes,
    },
};
</script>

<style scoped lang="scss">
.data-row {
    border: solid 1px #8f8f8f;
    border-bottom: none;
}
.data-row:last-child {
    border: solid 1px #8f8f8f;
}
#soap_chart .row {
    background: white;
    .picker-container {
        padding-left: 0px;
    }
}
</style>
